import React, { Component } from 'react'


import classnames from 'classnames'
export const Key = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  SPACE: 32,
  UP: 38,
  DOWN: 40,
  RIGHT: 39,
  LEFT: 37
}


function getDisplayName(WrappedComp) {
  const wrappedName = WrappedComp.displayName || WrappedComp.name || 'Component'
  return `Dropdown(${wrappedName})`
}

export default WrappedComp => class Dropdown extends Component {

  static displayName = getDisplayName(WrappedComp)

  dropdownIsMounted = false

  state = {
    active: false
  }

  componentDidMount() {
    this.el.addEventListener('focusout', this.blurHandler, true)

    this.dropdownIsMounted = true
  }

  componentWillUnmount() {
    if (this.el) this.el.removeEventListener('focusout', this.blurHandler, true)

    this.dropdownIsMounted = false
  }

  // -- Handlers ------------

  keyDownHandler = (e) => {
    if (e.keyCode === Key.TAB) {
      // wait until next tick to check what was tabbed _to_
      setTimeout(() => {
        // If the user _tabbed_ and we do not contain
        // the activeElement then assume they tabbed away
        if (!this.el.contains(document.activeElement)) {
          this.setActive(false)
        }
      }, 1)
    } else if (e.keyCode === Key.ESC) {
      // close dropdown and blur
      document.activeElement.blur()
      this.setActive(false)
    }
  }

  blurHandler = (e) => {
    let didBlur
    if (!this.el) {
      didBlur = false // not open yet
    } else if (e.relatedTarget) {
      didBlur = !this.el.contains(e.relatedTarget)
    } else {
      didBlur = true
    }
    if (didBlur) {
      this.setActive(false)
    }
  }

  focusHandler = () => {
    this.setActive()
  }

  // -- State ------------

  setActive(active=true, cb) {
    if (this.state.active && !active) {
      if (typeof this.options.onClose === 'function') {
        this.options.onClose()
      }
    } else if (!this.state.active && active) {
      if (typeof this.options.onOpen === 'function') {
        this.options.onOpen()
      }
    }
    if (this.dropdownIsMounted) this.setState({ active }, cb)
  }

  close = () => {
    this.setActive(false, () => {
      if (this.el.contains(document.activeElement)) {
        document.activeElement.blur()
      }
    })
  }

  // -- Rendering ------------

  getDropDown(dropdown, anchor) {
    if (!this.state.active || !dropdown) {
      return null
    }
    const className = classnames({
      'sidx-anchor-right' : anchor === 'right'
    })
    return (
      <FloatingMenu className={className}>
        {dropdown}
      </FloatingMenu>
    )
  }

  getContent(content) {
    return (
      <div>
        {content}
      </div>
    )
  }

  getTabIndex(content) {
    if ('tabIndex' in content.props) {
      return -1
    } else if(this.state.active) {
      return -1
    } else {
      return 0
    }
  }

  forceDropdownOpen = () => {
    this.setState({ active: true })
  }

  getRender = ({content, dropdown, options = {}}) => {
    options = Object.assign({
      props: {},
      anchor: 'left'
    }, options)
    this.options = options
    const mainContent = this.getContent(content)
    const dropContent = this.getDropDown(dropdown, options.anchor)
    const className = classnames('sidx-dropdown', options.props.className, {
      'sidx-active': this.state.active && dropContent
    })
    return (
      <div
        {...options.props}
        ref={el => this.el = el}
        className={className}
        onFocus={this.focusHandler}
        onKeyDown={this.keyDownHandler}>
        <FloatingMenuAnchor tabIndex={this.getTabIndex(content)}>
          {mainContent}
          {dropContent}
        </FloatingMenuAnchor>
      </div>
    )
  }

  render() {
    return (
      <WrappedComp
        dropdown={this.getRender}
        closeDropdown={this.close}
        isDropdownOpen={this.state.active}
        forceDropdownOpen={this.forceDropdownOpen}
        {...this.props} />
    )
  }
}


export class FloatingMenu extends Component {
  render() {
    let { className, ...others } = this.props
    className = classnames('sidx-floating-menu', className)
    return (
      <div className={className} {...others}>
        {this.props.children}
      </div>
    )
  }
}

export class FloatingMenuAnchor extends Component {
  render() {
    let { className, ...others } = this.props
    className = classnames('sidx-floating-menu-anchor', className)
    return (
      <div className={className} {...others}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/dropdown.js